import { render } from "./LoginKasir.vue?vue&type=template&id=089fe560&scoped=true"
import script from "./LoginKasir.vue?vue&type=script&lang=js"
export * from "./LoginKasir.vue?vue&type=script&lang=js"

import "./LoginKasir.vue?vue&type=style&index=0&id=089fe560&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-089fe560"

export default script